import { useInstantSearch } from "react-instantsearch-hooks-web";

type Props = {
    children: JSX.Element;
    fallback: JSX.Element | null;
};

function NoResultsBoundary({ children, fallback }: Props) {
    const { results } = useInstantSearch();

    // The `__isArtificial` flag makes sure not to display the No Results message
    // when no hits have been returned yet.
    // eslint-disable-next-line no-underscore-dangle
    if (!results.__isArtificial && results.nbHits === 0) {
        return fallback;
    }

    return children;
}

export default NoResultsBoundary;
